import {
  FilterOptionKeys,
  GoalGroupBy,
  GoalSortingMode,
  GroupByMode,
} from '@griply/types';

export const goalListGroupOptions = [
  GroupByMode.None,
  GroupByMode.LifeArea,
  GroupByMode.Deadline,
] as const satisfies GoalGroupBy[];

export const goalListSortOptions = [
  GoalSortingMode.Custom,
  GoalSortingMode.StartDate,
  GoalSortingMode.Deadline,
  GoalSortingMode.Name,
  GoalSortingMode.Progress,
  GoalSortingMode.Impact,
  GoalSortingMode.Tasks,
  GoalSortingMode.LifeArea,
] as const satisfies GoalSortingMode[];

export const goalListFilters = [
  FilterOptionKeys.LifeArea,
  FilterOptionKeys.Date,
  FilterOptionKeys.Deadline,
  FilterOptionKeys.GoalActive,
  FilterOptionKeys.GoalImpact,
] as const satisfies FilterOptionKeys[];

export const goalNoImpactFilterValue = 'none';
